import nanobus from 'nanobus';
/** @link https://github.com/choojs/nanobus#readme */

/**
 * Ensure single shared event bus across all packs
 */
window.Bravely.Events = window.Bravely.Events || nanobus('Bravely');

/**
 * List of All Events Emitted from BravelyEvent Bus
 */
window.Bravely.Events.EVENT = {
  SessionDetailsCollapsePane: 'SessionDetailsCollapsePane',
};

export default window.Bravely.Events;
